// The last line of defence: if drawing a screen throws, show what happened and a way out instead of a blank page.
import { Component, type ReactNode } from "react";

export class CrashScreen extends Component<{ children: ReactNode }, { error: Error | null }> {
  override state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  override componentDidCatch(error: Error) { console.error("Screen crashed:", error); }
  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="crash">
        <h2>Something went wrong</h2>
        <p className="hint">{this.state.error.message}</p>
        <button className="btn yellow" onClick={() => location.reload()}>Reload</button>
      </div>
    );
  }
}
